import { Form, InputNumber, Typography } from "antd";
import type { FormInstance } from "antd";
import { Customer } from "@lib/types/Customer";
import { customerSchema as yupSchema } from "@lib/schemas/customer";
import { createYupSync } from "@lib/helpers/TableHelper";
import useIntl from "react-intl/lib/src/components/useIntl";

type Props = {
  form: FormInstance<Customer>;
  customer: Customer;
  initialValues: Customer;
};

const AISettings: React.FC<Props> = ({
  form: _form,
  customer: _customer,
  initialValues: _initialValues,
}) => {
  const { messages } = useIntl();

  return (
    <div style={{ padding: "24px" }}>
      <Form.Item
        name="aiServicesMargin"
        label={messages["common.aiServicesMargin"] as string}
        rules={[createYupSync({ schema: yupSchema })]}
      >
        <InputNumber
          addonAfter={<Typography.Text>%</Typography.Text>}
          style={{ width: "100%" }}
          min={0}
          max={100}
        />
      </Form.Item>

      {/* Future AI settings fields will be added here */}
    </div>
  );
};

export default AISettings;
